import React from 'react';
import heroImage from '../../assets/imgs/csCenterHero.webp';
import BlackArrowBtn from '../../components/global/BlackArrowBtn';
import KakaoMapWithAddress from '../../components/kakao/KakaoMap';
import { Link } from 'react-router-dom';

function CsCenterMain({ firstSectionRef }) {
  return (
    <div className="csCenterMainPageWrapper">
      <div ref={firstSectionRef} className="subHeroSection">
        <div className="heroItem flex-col align-center justify-center">
          <div className="subHeroImage">
            <img src={heroImage} alt="" />
          </div>
          <div className="grid flex-col justify-center align-center">
            <div className="flex-col gap-48 justify-center align-center">
              <div className="mainText">
                <span>고객센터</span>
              </div>
              <div className="description">
                <span>
                  다년간의 클라우드 및 IDC 운영을 통해 축적한 노하우를 바탕으로,
                  전문가들이 1:1 상담해 드립니다.
                  <br />
                  다양한 문의방법과 지원 서비스를 제공해드리며, 언제든지 문의
                  주시면 친절히 답변해드리겠습니다.
                </span>
              </div>
              <div className="divide"></div>
            </div>
          </div>
        </div>
      </div>
      <div className="csSection py-96 flex-col align-center justify-center">
        <div className="grid">
          <div className="flex-col gap-48">
            <div className="titleWrap flex-col gap-24">
              <div className="accent flex-row gap-8">
                <span>CUSTOMER SERVICE</span>
              </div>
              <div className="title">
                <span>고객센터</span>
              </div>
              <div className="description">
                <span>1:1 상담을 통해 빠른 견적을 받아보세요</span>
              </div>
            </div>
            <div className="flex-col gap-40">
              <div className="csLinksWrap">
                <div className="telText">
                  <span>02-6406-6100</span>
                </div>
              </div>
              <div className="buttonsWrap flex-row gap-8">
                <BlackArrowBtn to={'/contact'} text={'컨설팅 신청'} />
                <div className="contactBtnWrap px-24 flex-row gap-8 justify-center align-center">
                  <Link to="/contact">
                    <div className="btnText">
                      <span>문의하기</span>
                    </div>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="locationSection pb-128 flex-col align-center justify-center">
        <div className="grid">
          <div className="flex-col gap-48">
            <div className="titleWrap pb-32 flex-col gap-24">
              <div className="accent flex-row gap-8">
                <span>LOCATION</span>
              </div>
              <div className="title">
                <span>오시는길</span>
              </div>
            </div>
            <div className="flex-row tab:flex-col gap-40 justify-between">
              <div className="locationListWrap flex-col gap-16">
                <div className="locationList flex-col gap-16">
                  <div className="item flex-row gap-8">
                    <div className="label">
                      <span>지하철</span>
                    </div>
                    <div className="detailItem flex-col gap-16">
                      <div className="contents">
                        <span>
                          <strong className={'subway'}>② </strong>뚝섬역 하차
                          (4번출구로부터 도보 12분)
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="item flex-row gap-8">
                    <div className="label">
                      <span>버스</span>
                    </div>
                    <div className="detailItem flex-col gap-16">
                      <div className="contens">
                        <span>
                          <strong>302번 </strong>리버하우스 정류장 하차
                        </span>
                      </div>
                      <div className="contens">
                        <span>
                          <strong>2012번 </strong>리버하우스 정류장 하차
                        </span>
                      </div>
                      <div className="contens">
                        <span>
                          <strong>463번 </strong>뚝섬서울숲 정류장 하자
                        </span>
                      </div>
                      <div className="contens">
                        <span>
                          <strong>2222번 </strong>리버하우스 정류장 하차
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="mapWrap">
                <KakaoMapWithAddress
                  address={'서울 성동구 성수일로 99'}
                  viewAddress={'서울숲AK밸리 506호'}
                />
                {/*<iframe*/}
                {/*  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3164.6642192849076!2d127.01542862621277!3d37.515836977033146!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x357ca3c2a48366f5%3A0x8d757ca508fe0c3a!2z6riI7IKw67mM65Sp!5e0!3m2!1sko!2skr!4v1743501968784!5m2!1sko!2skr"*/}
                {/*  style={{ border: 0, width: '100%', height: '100%' }}*/}
                {/*  loading="lazy"*/}
                {/*  allowFullScreen=""*/}
                {/*  referrerPolicy="no-referrer-when-downgrade"*/}
                {/*></iframe>*/}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CsCenterMain;
